var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"page bg-white column items-center no-wrap"},[_c('div',{staticClass:"code flex items-center justify-center"}),_c('search-form',_vm._b({},'search-form',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }